import React, { FC } from 'react';
import { Table } from 'semantic-ui-react';

import AddDishButton from 'components/AddDishButton';

import theme from './theme.scss';

type ExtraType = {
  id: string;
  name: string;
  price: number;
  isVegetarian: boolean;
};

type MenuTableProps = {
  dishes: {
    id: string;
    name: string;
    description: string;
    image: string;
    price: number;
    isVegetarian: boolean;
    category: {
      id: string;
      name: string;
    };
    addOns: ExtraType[];
    options: ExtraType[];
    notes: string;
    scheduledTime: string;
  }[];
  vendor: any;
};

const MenuTable: FC<MenuTableProps> = ({ dishes, vendor }) => {
  return (
    <div className={theme.menuTable}>
      <Table unstackable compact className={theme.itemTable}>
        <Table.Header className={theme.itemHeader}>
          <Table.Row>
            <Table.HeaderCell width="5">NAME</Table.HeaderCell>
            <Table.HeaderCell width="3" minWidth={992}>
              PRICE
            </Table.HeaderCell>
            <Table.HeaderCell width="8" textAlign="center">
              QUANTITY
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body className={theme.itemBody}>
          {dishes.map(dish => (
            <Table.Row key={dish.id} className={theme.itemRow}>
              <Table.Cell width="5">{dish.name}</Table.Cell>
              <Table.Cell width="3" minWidth={992}>
                ₹ {dish.price}
              </Table.Cell>
              <Table.Cell width="8" textAlign="center">
                <AddDishButton dish={dish} vendor={vendor} />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      {dishes && dishes.length > 0 ? null : (
        <div className={theme.emptyMessage}>There are no dishes added yet.</div>
      )}
    </div>
  );
};

export default MenuTable;
